<mpb-banner></mpb-banner>
<router-outlet></router-outlet>
<mpb-loader *ngIf="isAppLoading$"></mpb-loader>
